export const initialPassMinRequirements = [
  {
    isValid: false,
    validatior: (pass: string) => pass.length >= 9,
    message: 'Lozinka mora sadržavat minimalno 9 znakova',
  },
];

export const initialPassMustContain = [
  {
    isValid: false,
    validatior: (pass: string) => new RegExp(/[A-Z]/).test(pass),
    message: 'Velika slova (A - Z)',
  },
  {
    isValid: false,
    validatior: (pass: string) => new RegExp(/[a-z]/).test(pass),
    message: 'Mala slova (a - z)',
  },
  {
    isValid: false,
    validatior: (pass: string) => new RegExp(/[0-9]/).test(pass),
    message: 'Brojevi (0 - 9)',
  },
  {
    isValid: false,
    validatior: (pass: string) => new RegExp(/[!@#$%^&*]/).test(pass),
    message: 'Posebni znakovi (!@#$%^&*)',
  },
];
